module.exports = __webpack_public_path__ + "img/protester5.99dfffb3.jpg";